import { render } from "./indexfive-blog.vue?vue&type=template&id=d16f87fc"
import script from "./indexfive-blog.vue?vue&type=script&lang=js"
export * from "./indexfive-blog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__